import GenericExplanation from '../../common/V2/GenericExplanation.react';

export default GenericExplanation;
